import React from 'react';
import styles from './../CardsList.module.less';
import ImageCard, { EcmImageCardProps } from './ImageCard';

type EcmLinkCardProps = EcmImageCardProps & {
  CTAButtonLabel?: string;
  CTAButtonURL?: string;
};

type LinkCardProps = {
  ecmContent: EcmLinkCardProps;
};

const LinkCard: React.FC<LinkCardProps> = ({ ecmContent }) => {
  const { CTAButtonLabel, CTAButtonURL } = ecmContent;

  return (
    <div>
      <ImageCard ecmContent={ecmContent} />
      {CTAButtonLabel && CTAButtonURL && (
        <a href={CTAButtonURL} className={styles.card_button}>
          {CTAButtonLabel}
        </a>
      )}
    </div>
  );
};

export default LinkCard;
